import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '@/features/currency/users-page';

export const Route = createFileRoute('/_app/settings/users')({
  component: UsersPage,
});
